<script setup>
import { useShared } from '../state.js';
import { usePanelRequests } from '../use_panels.js';

const { isStale, recompute } = useShared();
const { requestPanel } = usePanelRequests();

async function onClick() {
  await recompute();
  requestPanel('calculated');
}
</script>

<template>
  <button
    v-if="isStale"
    @click="onClick()"
    class="btn-recompute" >
    Recalculate (inputs changed)
  </button>
</template>
